/**
 * 钱包流水导出天数
 */
export const WALLET_EXPORT_DAYS = 180

/**
 * 币种符号
 * 补充
 */
export const COUNTRY_SYMBOL_MAP = {
  MYR: 'RM',
  THD: '฿',
}
